module.exports = __webpack_public_path__ + "img/e-class.453e3564.jpg";